<template>
  <div class="content">
    <div class="main">
      <ConfigShow ref="ConfigShow"></ConfigShow>
      <ConfigExecModal ref="ConfigExecModal"></ConfigExecModal>
      <Modal v-model="execLogDetailModal" title="设备执行结果" :width="1000" footer-hide>
        <Alert>
          <div class="exec-logs-detail-c">
            <Row v-if="execLogDetail.datetime">
              <span class="span-dt">执行时间: </span><span>{{ execLogDetail.datetime_format }}</span>
            </Row>
            <Row v-if="execLogDetail.user_full_name">
              <span class="span-dt">执行用户: </span><span>{{ execLogDetail.user_full_name }}</span>
            </Row>
            <Row v-if="execLogDetail.version">
              <span class="span-dt">版本: </span><span>{{ execLogDetail.version.version_id }}</span>
              （<a v-on:click="$refs.ConfigShow.openModal(execLogDetail.version)">查看配置</a>）
            </Row>
            <Row v-if="execLogDetail.params">
              <span class="span-dt">参数: </span><span>{{ execLogDetail.params }}</span>
            </Row>
            <Row v-if="execLogDetail.status">
              <span class="span-dt">状态: </span>
              <span v-if="execLogDetail.status === '队列中'">
                <Icon type="md-clock" size="18" style="color: #2d8cf0" /><span style="color: #2d8cf0">队列中</span>
              </span>
              <span v-if="execLogDetail.status === '完成'">
                <Icon type="md-checkmark" size="18" style="color: #19be6b" /><span style="color: #19be6b">完成</span>
              </span>
              <span v-if="execLogDetail.status === '执行中'">
                <Icon type="ios-loading" size="18" style="color: #ff9900; animation: ani-demo-spin 1s linear infinite" />
                <span style="color: #ff9900">执行中</span>
              </span>
            </Row>
          </div>
        </Alert>
        <div v-if="execLogDetail.result_json">
          <span class="span-dt" style="font-size: 15px">结果: </span>
          <json-viewer
            :value="getJson(execLogDetail.result_json)"
            :expand-depth="3"></json-viewer>
        </div>
      </Modal>
      <div>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="15">
            <div>
              <Row class="title">
                <h4 :style="{float: 'left'}">设备详情</h4>
                <div :style="{float: 'right'}">
                  <Button @click="$router.push({ name: 'asset-manage' })">返回</Button>
                </div>
              </Row>
              <Alert v-if="infoError" type="warning" show-icon>获取设备数据失败</Alert>
              <div class="info-property" v-else>
                <!-- <dl>
                  <dt>ID</dt><dd>{{ info.id }}</dd>
                </dl> -->
                <dl>
                  <dt>设备名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>品牌</dt><dd>{{ info.brand }}</dd>
                </dl>
                <dl>
                  <dt>型号</dt><dd>{{ info.model }}</dd>
                </dl>
                <dl>
                  <dt>设备管理地址</dt><dd>{{ info.asset_ip }}</dd>
                </dl>
                <dl>
                  <dt>设备类型</dt><dd><Tag color="blue">{{ assetTypeList.filter(item => item.value === info.asset_type).map(m => m.label)[0] }}</Tag></dd>
                </dl>
                <dl>
                  <dt>设备软件版本号</dt><dd>{{ info.version }}</dd>
                </dl>
                <dl>
                  <dt>设备镜像名称</dt><dd>{{ info.mirror }}</dd>
                </dl>
                <dl>
                  <dt>最后一次重启时间</dt><dd>{{ info.reboot_time }}</dd>
                </dl>
                <dl>
                  <dt>正常运行时长</dt><dd>{{ info.run_time }}</dd>
                </dl>
              </div>
            </div>
            <div>
              <Row class="title" :style="{marginTop: '15px'}">
                <h4 :style="{float: 'left'}">配置恢复执行记录</h4>
                <a v-on:click="getExecLogs()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
              </Row>
              <Row>
                <Alert v-if="execHistory.error" type="warning" show-icon>获取执行记录数据失败</Alert>
                <Table
                  v-else
                  border
                  size="small"
                  :height="tableHeight"
                  :loading="execHistoryLoading"
                  ref="table"
                  :data="execHistory.data"
                  :columns="execHistory.columns"
                  class="mob-remove-table-fixed">
                </Table>
                <div style="margin: 10px 0; overflow: hidden;">
                  <div style="float: right;">
                    <page
                      :total="execHistory.count"
                      :current="execHistory.page"
                      :page-size="execHistory.size"
                      @on-change="getExecLogs"></page>
                  </div>
                </div>
              </Row>
            </div>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="{ span: 8, offset: 1 }">
            <Row class="title" :style="{marginTop: '15px'}">
              <h4 :style="{float: 'left'}">配置备份版本</h4>
            </Row>
            <Row>
              <Alert v-if="versionHistory.error" type="warning" show-icon>获取配置版本历史数据失败</Alert>
              <Table
                v-else
                border
                size="small"
                :height="tableHeight"
                ref="versionTable"
                :data="versionHistory.data"
                :columns="versionHistory.columns">
              </Table>
              <div style="margin: 10px 0; overflow: hidden;">
                <div style="float: right;">
                  <page
                    :total="versionHistory.count"
                    :current="versionHistory.page"
                    :page-size="versionHistory.size"
                    @on-change="getVersionHistory"></page>
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { detailConfigExecLogs, getConfigExecLogs, detailNetworkServer, getConfigVersionHistory, rollbackServer, deleteConfigVersion } from '@/api/network'
import ConfigShow from './config-show'
import { getJsonFun } from '../../../src/libs/tools'
import codemirror from '../ops-center/scriptUse.js'
import ConfigExecModal from './config-exec-modal'

export default {
  name: 'asset-detail',
  components: {
    ConfigShow,
    codemirror,
    ConfigExecModal
  },
  watch: {
    '$route' () {
      if (this.$route.query.id) {
        this.init()
      }
    }
  },
  data () {
    return {
      assetTypeList: [
        // {
        //   value: 0,
        //   label: '软件'
        // },
        // {
        //   value: 1,
        //   label: '硬件'
        // },
        {
          value: 2,
          label: '交换设备'
        },
        {
          value: 3,
          label: '路由设备'
        },
        {
          value: 4,
          label: '防火墙'
        },
        {
          value: 5,
          label: '负载均衡'
        }
        // {
        //   value: 9,
        //   label: '未知'
        // }
      ],
      contentTypeId: '',
      info: {},
      infoError: false,
      detailCmOptions: {
        mode: {
          name: 'shell'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'monokai',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        readOnly: true,
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      },
      tableHeight: 0,
      execHistory: {
        data: [],
        columns: [
          {
            title: '执行时间',
            key: 'datetime_format',
            align: 'center',
            minWidth: 150
          },
          {
            title: '执行用户',
            key: 'user_full_name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '执行状态',
            key: 'status',
            minWidth: 100,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              let iconType = 'md-clock'
              let style = {
                color: '#2d8cf0'
              }
              if (params.row.status === '完成') {
                iconType = 'md-checkmark'
                style.color = '#19be6b'
              } else if (params.row.status === '执行中') {
                iconType = 'ios-loading'
                style.color = '#ff9900'
                style.animation = 'ani-demo-spin 1s linear infinite'
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: iconType,
                    size: 20
                  },
                  style: style
                }),
                h('span', {
                  style: {
                    color: style.color
                  }
                }, ' ' + params.row.status)
              ])
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.getExecLogDetail(params.row.id)
                    }
                  }
                }, '详情')
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 5
      },
      execHistoryLoading: false,
      execLogDetailModal: false,
      execLogDetail: {},
      RevisionLogs: [],
      versionHistory: {
        data: [],
        columns: [
          {
            title: '版本名称',
            align: 'center',
            minWidth: 120,
            key: 'version_id'
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 150,
            key: 'created_format'
          },
          {
            title: '操作',
            width: 240,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.ConfigShow.openModal(params.row)
                    }
                  }
                }, '查看'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.ConfigExecModal.openModal(params.row)
                    }
                  }
                }, '对比'),
                h('Poptip', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    confirm: true,
                    placement: 'left',
                    title: '你确定要恢复到当前配置吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.rollback(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '恢复')
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'left',
                    title: '你确定要删除当前备份版本吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.deleteVersion(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 10
      }
    }
  },
  created () {
    console.log('created')
  },
  computed: {
    myCodeMirror () {
      return this.$refs.detailCm.editor
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.getData()
      this.getExecLogs()
      this.getVersionHistory()
    },
    typeChange (value) {
      const lang = ConfigTypeChange(value)
      this.myCodeMirror.setOption('mode', { name: lang })
    },
    // 获取设备数据
    getData () {
      this.infoError = false
      detailNetworkServer(this.$route.query.id).then(res => {
        this.info = res.data
      }).catch(res => {
        this.infoError = true
        this.$Notice.error({ title: '获取设备数据失败' })
      })
    },
    // 跳转到编辑页
    edit () {
      this.$router.push({
        name: 'Config_edit',
        params: { id: this.$route.query.id }
      })
    },
    // 获取修改记录
    revisionLog () {
      let params = {
        object_id: this.$route.query.id,
        content_type: this.contentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      }).catch(res => {
        this.$Notice.error({ title: '获取修改记录失败' })
      })
    },
    // 获取设备执行记录
    getExecLogs (value = 1) {
      this.execHistory.page = value
      let params = {
        size: this.execHistory.size,
        page: this.execHistory.page,
        server: this.$route.query.id
      }
      this.execHistory.error = false
      this.execHistoryLoading = true
      getConfigExecLogs(params).then(res => {
        this.execHistoryLoading = false
        this.execHistory.data = res.data.results
        this.execHistory.count = res.data.count
      }).catch(res => {
        this.execHistoryLoading = false
        this.execHistory.data = []
        this.execHistory.count = 0
        this.execHistory.error = true
        this.$Notice.error({ title: '获取执行记录数据失败' })
      })
    },
    // 获取设备执行记录详情
    getExecLogDetail (id) {
      this.execLogDetail = {}
      detailConfigExecLogs(id).then(res => {
        this.execLogDetail = res.data
        this.execLogDetailModal = true
      }).catch(res => {
        this.$Notice.error({ title: '获取执行记录详情数据失败' })
      })
    },
    // 获取版本历史记录
    getVersionHistory (value = 1) {
      this.versionHistory.page = value
      let params = {
        size: this.versionHistory.size,
        page: this.versionHistory.page,
        server: this.$route.query.id
      }
      getConfigVersionHistory(params).then(res => {
        this.versionHistory.data = res.data.results
        this.versionHistory.count = res.data.count
      }).catch(res => {
        this.versionHistory.data = []
        this.versionHistory.count = 0
        this.versionHistory.error = true
        this.$Notice.error({ title: '获取版本历史数据失败' })
      })
    },
    getJson (data) {
      return getJsonFun(data)
    },
    // 将交换机恢复到当前配置
    rollback (params) {
      let data = { data: params }
      rollbackServer(data).then(res => {
        let result = res.data
        if (result.code === 200) {
        } else {
          this.$Notice.error({
            title: '恢复失败！失败状态码:' + result.code,
            desc: result.msg
          })
        }
      })
    },
    // 删除配置备份版本
    deleteVersion (row) {
      deleteConfigVersion(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getVersionHistory()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../ops-center/base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .logs-scroll-bar {
    height: 750px;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .span-dt {
    font-weight: bold;
  }
  .exec-logs-detail-c {
    font-size: 15px
  }
  .exec-logs-detail-c .ivu-row {
    line-height: 25px;
  }
</style>
